// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
exports.push([module.id, "@import url(https://fonts.googleapis.com/css?family=Nunito:300,600,700&display=swap);"]);
// Module
exports.push([module.id, ".ForgotPasswordRequestScreen{background-image:linear-gradient(-225deg, rgba(232,33,114,0.8), rgba(249,207,14,0.8));min-height:100vh;display:flex;flex-direction:column}.ForgotPasswordRequestScreen .ForgotPasswordRequestContainer{height:100%}.ForgotPasswordRequestScreen .ForgotPasswordRequestContainer .Logo{width:40px;height:40px}.ForgotPasswordRequestScreen .facebook-button img{width:40px;height:40px}\n", ""]);
// Exports
module.exports = exports;
